module.exports = __webpack_public_path__ + "static/media/cross-light.5b36f1ef.svg";